import { render, staticRenderFns } from "./PermissionRoleEdit.vue?vue&type=template&id=5e5ecbef&scoped=true&"
import script from "./PermissionRoleEdit.vue?vue&type=script&lang=js&"
export * from "./PermissionRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ecbef",
  null
  
)

export default component.exports